// extracted by mini-css-extract-plugin
module.exports = {"container":"MaxWidth_container__Gmu97","small":"MaxWidth_small__sD7tB","medium":"MaxWidth_medium__T7JVi","large":"MaxWidth_large__cb2QR"};